import * as _ from 'lodash';
export interface FruitBasketType {
  fruitId: string;
  currentStatus?: string;
  location?:
    | 'Brisbane'
    | 'Gold Coast'
    | 'SunShine Coast'
    | 'Toowoomba'
    | 'Others'
    | 'Not Sure';
  visaStatus?:
    | 'Working Visa'
    | 'Student Visa'
    | 'Permanent Resident'
    | 'Citizens'
    | 'Less than 1 year'
    | 'Less than 2 Years'
    | 'Not Sure';
  religion?:
    | 'Pending'
    | 'Christian'
    | 'Non-believer'
    | 'Agnostic'
    | 'Atheist'
    | 'Muslim'
    | 'Buddhist'
    | 'Hindu'
    | 'Catholic'
    | 'SDA'
    | 'Mormon'
    | 'Others'
    | 'Not Sure'
    | 'Jehovah\'s Witnesses'
    | 'Sikhism';
  responsibility?: responsibilityType[];
  schedule?: unknown; //TODO: decide it later
  interest?: 'Yes' | 'No' | 'Pending';
  plans?: plansType[];
  notes?: string;
  fisherman: string;
  textedDate?: { seconds: number };
  repliedDate?: { seconds: number };
  findingDate?: { seconds: number };
  firstMeetingDate?: { seconds: number };
  pickDate?: { seconds: number };
  dropDate?: { seconds: number };
  dropReason: string;
  centerClass: string;
  replyStatus?:
    | 'First meeting arranged'
    | 'First meeting done'
    | 'DV'
    | 'GBB'
    | 'BB'
    | 'SGBB'
    | 'Center'
    | 'Paused';
}

type responsibilityType =
  | 'Full-time worker'
  | 'Parent'
  | 'Uni Student'
  | 'Part-time worker';

interface plansType {
  plan: string;
  feedbackAuthor: string;
  createdAt: dateType;
}

export interface FruitPropsType extends FruitPropsFirebaseType {
  pasteFormat?: boolean; //CHILD TYPE
  status?: FruitStatusType; //CHILD TYPE
  pending?: boolean; //CHILD TYPE
  url?: string; //CHILD TYPE
  methodType?: methodType;
}

export const removeFruitPropsExtraInfo = (fruit: FruitPropsType) => {
  delete fruit.pasteFormat;
  delete fruit.status;
  delete fruit.pending;
  delete fruit.methodType;


  const fruitRemoveUndefined = _.pickBy(fruit, _.identity);
  return fruitRemoveUndefined as FruitPropsFirebaseType;
};


export type centerClassType = '144-1'| '145'| '146'| '147'| '148'|'149'|'Not Sure'

export interface FruitPropsFirebaseType extends FruitPropsFirebaseTypeOptions{
  id: string;
  name: string;
  platform: Platform;
  version: 2 | 3;
  
}
export interface FruitPropsFirebaseTypeOptions {
  facebookUserId?: string;
  instagramId?: string;
  facebookUsername?: string;
  nickName?: string;
  image?: string;
  others?: string;
  fisherman?:string;
  fishermans?: FishermansType[];
  facebookGroupIds?: string[];
  notSuitableReasonCollections?: notSuitableType[];
  notSuitableReasonsCount?: number;
  isBlacklist?: true;
  isFamilyMember?:true;
  isPastor?:true;
  blacklistCenterClass?:centerClassType;
  blacklistReason?: string;
  createdAt?: dateType;
  isLocked?: isLockedType[]
  harvestland?:true
  pastorsFacebookUserId?:string[]
  pastorsInstagramId?:string[] 
  pastorsFacebookUsername?:string[]
}
export interface isLockedType {
  name: string,
  createdAt: dateType
}
export interface notSuitableType {
  fishermans: string;
  reasons: 'Family Member' | 'Pastors / Church workers';
  createdAt?: dateType;
}

type fruitUniqueType = 'facebookUserId' | 'facebookUsername' | 'name' | 'id';


export interface dateType {
  seconds: number;
  nanoseconds: number;
}

export interface FishermansType {
  name: string;
  createdAt: dateType;
  methodType: methodType;
}

export interface visitorsType {
  name: string;
  createdAt: dateType;
}

export interface FacebookGroupsType {
  id: string;
  name: string;
}

export type FruitStatusType = 'Available' | 'Texted' | 'Filtered' |'Removed' |'All'| 'Blacklisted';
export type Platform = 'Facebook' | 'Instagram' | 'Bumble' | 'Other';
export type methodType =
  | 'InstagramFollowerFollowing'
  | 'InstagramSearch'
  | 'FacebookGroup'
  | 'FacebookFriend'
  | 'FacebookSearch'
  | 'FacebookSearchPeople'
  | 'Not sure';

//good example: Laura Tiro
export interface FruitPropsTypeVersion1Type {
  fisherman: string;
  date: string;
  name: string;
  platform: 'Facebook' | 'Instagram' | 'Others';
  id: string;
  centerClass?: string;
  blacklist?: true;
  blacklistReason?: string;
  blacklistDate?: dateType;
}

// good example: Louise Butcher, Susan Talia Patterson
export interface FruitPropsTypeVersion2Type {
  fisherman: string;
  gender?: 'female' | 'male';
  genderScore?: number;
  createdAt: dateType;
  date?: string;
  others: string;
  platform: 'Facebook' | 'Instagram' | 'Others';
  tlistChecked: boolean;
  image: string;
  name: string;
  url: string;
  id: string;
  centerClass?: string;
  blacklist?: true;
  blacklistReason?: string;
  blacklistDate?: {
    seconds: number;
    nanoseconds: number;
  };
}


export interface checkedFishType {
  [key :string]: any[]
}